import { render, staticRenderFns } from "./dossiers.vue?vue&type=template&id=10df97c7&scoped=true"
import script from "./dossiers.vue?vue&type=script&lang=js"
export * from "./dossiers.vue?vue&type=script&lang=js"
import style0 from "./dossiers.vue?vue&type=style&index=0&id=10df97c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10df97c7",
  null
  
)

export default component.exports